/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:06:06
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-07 14:48:34
 */
import req from "@/utils/request";

//  征集调查列表
export const findListPage = (params) => req.post("/interact-service/m/isInterview/findListPage", params);
export const updateDisplayStatus = (params) => req.post("/interact-service/m/isInterview/updateDisplayStatus", params);
export const collectDelete = (params) => req.post("/interact-service/m/isInterview/delete", params);
export const findLogList = (params) => req.post("/interact-service/m/isInterviewOperateLog/findLogList", params);
export const saveInterview = (params) => req.post("/interact-service/m/isInterview/saveInterview", params);
export const saveLiveSet = (params) => req.post("/interact-service/m/isInterviewLiveSet/saveLiveSet", params);
export const updateLiveSet = (params) => req.post("/interact-service/m/isInterviewLiveSet/updateLiveSet", params);
export const findLiveSet = (params) => req.post("/interact-service/m/isInterviewLiveSet/findLiveSet", params);
export const getDelOnline = (params) => req.post("/interact-service/m/isInterview/id", params);
export const updateInterview = (params) => req.post("/interact-service/m/isInterview/updateInterview", params);
export const chatRoomList = (params) => req.post("/interact-service/m/isInterviewChatMessage/findListPage", params);
export const updateTaboo = (params) => req.post("/interact-service/m/isInterviewChatMessage/updateTaboo", params);
export const findChatLogList = (params) => req.post("/interact-service/m/isInterviewChatOperateLog/findChatLogList", params);
export const saveWordMemoir = (params) => req.post("/interact-service/m/isInterviewWordMemoir/saveWordMemoir", params);
export const findWordMemoirList = (params) => req.post("/interact-service/m/isInterviewWordMemoir/findWordMemoirList", params);
export const updateWordMemoir = (params) => req.post("/interact-service/m/isInterviewWordMemoir/updateWordMemoir", params);
export const deleteWordMemoir = (params) => req.post("/interact-service/m/isInterviewWordMemoir/deleteWordMemoir", params);
export const delChatMessageOne = (params) => req.post("/interact-service/m/isInterviewChatMessage/delChatMessageOne", params);






















